<template>
  <div>
    <el-dialog title="新增菜单" :visible.sync="addDialogVisible" class="imgbox" width="35%" :before-close="resetForm" :append-to-body="true" :close-on-click-modal="false">
      <el-form label-width="110px" ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input v-model.trim="form.menuName" autocomplete="off" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="菜单优先级" prop="menuPriority">
          <el-input v-model.trim="form.menuPriority" autocomplete="off" placeholder="请输入菜单优先级"></el-input>
        </el-form-item>
        <el-form-item label="菜单路径" prop="menuUrl" >
          <el-input v-model.trim="form.menuUrl" autocomplete="off"  placeholder="请输入菜单路径"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" prop="menuIcon" >
          <el-input v-model.trim="form.menuIcon" autocomplete="off" placeholder="请输入菜单图标"></el-input>
        </el-form-item>
        <el-form-item label="父菜单" prop="parentMenuId">
          <!-- <el-input v-model="form.parentMenuId" autocomplete="off"  placeholder="请输入父级菜单"></el-input> -->
          <el-tree
          :render-after-expand="false"
            ref="tree"
            :data="permissionList"
            show-checkbox
            node-key="menuId"
            :check-strictly="true"
            @check-change="checkChange"
            @node-click="handleNodeClick"
            :props="defaultProps">
          </el-tree>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" autocomplete="off"  placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addMenu, listOwnerMenu } from '@/api/modelManager'
import { mapGetters } from 'vuex'
import { eventBus } from '@/utils/eventBus'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const priorityValidator = (rule, value, callback) => {
      const reg = /^[0-9]*$/
      console.log(typeof value)
      if (value.length > 20) {
        callback(new Error('请输入20个字符内的菜单优先级'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入数字优先级！'))
      } else {
        callback()
      }
    }
    return {
      form: {
      },
      rules: {
        menuName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { max: 20, message: '请输入20个字符内的菜单名称', trigger: 'blur' }
        ],
        menuType: [
          { required: true, message: '请选择菜单类型', trigger: 'change' }
        ],
        menuPriority: [
          { required: true, message: '请输入菜单的优先级', trigger: 'change' },
          { validator: priorityValidator, trigger: 'blur' }
        ],
        menuIcon: [
          { max: 20, message: '请输入20个字符内的菜单图标', trigger: 'blur' }
        ],
        menuUrl: [
          { required: true, message: '请输入菜单路径', trigger: 'change' },
          { max: 40, message: '请输入40个字符内的菜单路径', trigger: 'blur' }
        ]
      },
      permissionList: [],
      // 树形控件
      defaultProps: {
        children: 'childMenus',
        label: 'menuName'
      },
      // defaultCheckedKeys: []
      checkedId: ''

    }
  },
  created () {
    // 解决select设置多选(multiple) 触发formItem校验
    this.$set(this.form, 'charactor', [])
    this.$set(this.form, 'distributionProduct', [])
    if (this.getCacheListOwnerMenu) {
      this.permissionList = JSON.parse(this.getCacheListOwnerMenu)
    } else {
      this.getMenuList()
    }
  },
  computed: {
    ...mapGetters(['getCacheListOwnerMenu'])
  },
  methods: {
    getMenuList () {
      listOwnerMenu().then(res => {
        console.log(res.data.data)
        if (res.data.code === 200 || res.data.code === 0) {
          this.permissionList = res.data.data
        }
      })
    },
    // 属性数据处理
    handleNodeClick (data) {
    },
    // 现在只是做父级上的互斥
    checkChange (data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
      if (checked) {
        this.$refs.tree.setCheckedKeys([data.menuId])
        this.form.parentMenuId = data.menuId
      }
      // const indexs = this.selectOrg.orgsid.indexOf(data.id)
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        console.log(this.form)
        if (valid) {
          const params = Object.assign({}, this.form)
          addMenu(params).then((res) => {
            console.log(res)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.$emit('closeAddDialog', 1)
              eventBus.$emit('updataMentList')// 更新左侧菜单
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeAddDialog')
    }
  }
}
</script>

<style lang='less' scoped>

</style>
